import {
  initialState,
  AuthActions,
  AuthState,
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_ERROR,
  SIGN_IN_GOOGLE_ERROR,
  SIGN_IN_GOOGLE_SUCCESS,
  SIGN_IN_GOOGLE,
  SIGN_IN_GOOGLE_RESET,
  SIGN_OUT,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_ERROR,
} from './types'

const reducers = (state: AuthState = initialState, action: AuthActions): AuthState => {
  switch (action.type) {
    case SIGN_IN:
      return {
        ...state,
        signInMethod: 'Manual',
        data: action.payload,
        signInStates: {
          loading: true,
          success: false,
          error: false,
        },
      }
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        data: action.payload,
        signInStates: {
          loading: false,
          success: true,
          error: false,
        },
      }
    case SIGN_IN_ERROR:
      return {
        ...state,
        data: null,
        errorCause: action?.payload?.errorCause,
        signInStates: {
          loading: false,
          success: false,
          error: true,
        },
      }
    case SIGN_IN_GOOGLE:
      return {
        ...state,
        signInMethod: 'Google',
        token: action.payload.token,
        googleStates: {
          loading: true,
          success: false,
          error: false,
        },
      }
    case SIGN_IN_GOOGLE_SUCCESS:
      return {
        ...state,
        accountExist: action.payload,
        googleStates: {
          loading: false,
          success: true,
          error: false,
        },
      }
    case SIGN_IN_GOOGLE_ERROR:
      return {
        ...state,
        token: action?.payload?.token,
        errorCause: action?.payload?.errorCause,
        googleStates: {
          loading: false,
          success: false,
          error: true,
        },
      }
    case SIGN_IN_GOOGLE_RESET:
      return {
        ...state,
        accountExist: null,
        token: null,
        googleStates: {
          loading: false,
          success: false,
          error: false,
        },
      }
    case SIGN_OUT:
      return {
        ...state,
        signOutStates: {
          loading: true,
          success: false,
          error: false,
        },
      }
    case SIGN_OUT_SUCCESS:
      return {
        ...state,
        signOutStates: {
          loading: false,
          success: true,
          error: false,
        },
      }
    case SIGN_OUT_ERROR:
      return {
        ...state,
        signOutStates: {
          loading: false,
          success: false,
          error: true,
        },
      }
    default:
      return state
  }
}

export default reducers
